import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'

import App from './App'
import { store } from '@/store/store'
import { AuthProvider } from '@/contexts/AuthProvider'
import { ChatProvider } from '@/contexts/ChatContext'
import { CurrencyProvider } from '@/components/currency'
import { SnackbarProvider, useSnackbarContext } from '@/components/ui/SnackbarProvider'
import { setGlobalSnackbar, setApiStoreRef } from '@/services/api'
import { clearTokens, setTokens } from '@/store/slices/authSlice'

import './index.css'

// Set up API store reference for token handling
setApiStoreRef(store, clearTokens, setTokens)

// Bridge to allow non-React code (e.g., API interceptors) to show snackbars
const GlobalSnackbarBridge: React.FC = () => {
    const { showError } = useSnackbarContext()
    useEffect(() => {
        setGlobalSnackbar({ error: (msg: string) => showError(msg) })
    }, [showError])
    return null
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter
            future={{
                v7_startTransition: true,
                v7_relativeSplatPath: true
            }}
        >
            <HelmetProvider>
                <Provider store={store}>
                    <AuthProvider>
                        <ChatProvider>
                            <CurrencyProvider defaultCurrency="USD" autoDetectCurrency={true}>
                                <SnackbarProvider>
                                    <GlobalSnackbarBridge />
                                    <App />
                                </SnackbarProvider>
                            </CurrencyProvider>
                        </ChatProvider>
                    </AuthProvider>
                </Provider>
            </HelmetProvider>
        </BrowserRouter>
    </React.StrictMode>,
)